import { keys, entries } from "lodash";

const advisorPortalBase = process.env.REACT_APP_ADVISOR_PORTAL_BASE;

const apps = {
  investorDetail: "views/accountHolders/Holder/HolderEdit/HolderEdit",
  accountDetail: "views/account/AccountDetail/AccountDetail",
  AmlProfilePage: "react/views/aml-review/AmlProfilePage",
  InvestorAmlPage: "react/views/aml-review/InvestorAmlPage"
} as const;

export function getAdviserLink(app: keyof typeof apps, params: Record<string, string> = {}) {
  const link = `${advisorPortalBase}#${apps[app]}`;
  if (keys(params).length > 0) {
    const urlParams = new URLSearchParams();
    entries(params).forEach(([key, value]) => {
      if (value != null) {
        urlParams.set(key, value.toString());
      }
    });
    return `${link}?${urlParams.toString()}`;
  }
  return link;
}
